module.exports = __webpack_public_path__ + "static/media/plans.a680c36d.svg";